import { render, staticRenderFns } from "./runHolidays.vue?vue&type=template&id=444ca5a2&"
import script from "./runHolidays.vue?vue&type=script&lang=js&"
export * from "./runHolidays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports